import { observer } from 'mobx-react-lite';
import React from 'react';

import type { Campaign } from '@feathr/blackbox';
import { useStore } from '@feathr/extender/state';

import * as styles from './EmailTemplateThumbnail.css';

import noImg from 'images/no-img.png';

interface IProps {
  campaign: Campaign;
}

function EmailTemplateThumbnail({ campaign }: IProps) {
  const { Templates } = useStore();

  // Get the url for the template thumbnail
  const templateId = campaign.get('template_id');
  const template = templateId ? Templates.get(templateId) : undefined;

  // If there is no template, return an element with noImg as the source
  if (!template) {
    return <img alt={''} className={styles.image} src={noImg} />;
  }
  const url = template.get('thumbnail_url', noImg);
  return <img alt={''} className={styles.image} src={url} />;
}

export default observer(EmailTemplateThumbnail);
